module.exports = __webpack_public_path__ + "aef71a532a1ae4b21b36aa86318345a4.MP3";